import React from "react";
import styles from "./styles.module.scss";
import ModalLayout from "../ModalLayout/ModalLayout";
import { cls } from "app/utils";
import { AddToRecruitProfileProps } from "app/components/Button/AddToRecruitProfile/index.types";
import { useTranslation } from 'react-i18next';

const AddToRecruitPostModal = ({
  modalOpen,
  onModalClose,
  yesClickHandler,
}: AddToRecruitProfileProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalLayout isOpen={modalOpen} onClose={onModalClose}>
        <div className={styles.container}>
          <h1 className={styles.title}>
            {t("Are you sure you want to add this post to your Recruit profile?")}
          </h1>
          <div className={styles.button_container}>
            <button
              className={cls(styles.done_button, "btn btn-primary")}
              onClick={yesClickHandler}
            >
              {t("Yes")}
            </button>
            <button
              className={cls(styles.done_button, "btn btn-outline-secondary")}
              onClick={onModalClose}
            >
              {t("Cancel")}
            </button>
          </div>
        </div>
      </ModalLayout>
    </>
  );
};

export default AddToRecruitPostModal;
